import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { GroupProtectedRoute } from '../../components/auth/GroupProtectedRoute';
import { FEATURE_GROUPS } from '../../features.config';
import { DashboardPage } from '../../pages/DashboardPage';
import { RunDashboard } from '../../pages/RunDashboard';
import { RunDetail } from '../../pages/RunDetail';
import { ParameterSetManager } from '../../pages/ParameterSetManager';
import { CollectionsPage } from '../../pages/CollectionsPage';
import { ClassSearchPage } from '../../pages/ClassSearchPage';

export const CaapRoutes: React.FC = () => (
  <GroupProtectedRoute requiredGroup={FEATURE_GROUPS.caap}>
    <Routes>
      <Route index element={<DashboardPage />} />
      <Route path="runs" element={<RunDashboard />} />
      <Route path="runs/:runId" element={<RunDetail />} />
      <Route path="parameters" element={<ParameterSetManager />} />
      <Route path="collections" element={<CollectionsPage />} />
      <Route path="classes" element={<ClassSearchPage />} />
    </Routes>
  </GroupProtectedRoute>
);
